import { getSupabase } from '@/systems/SupabaseClient';

/**
 * AdminService — leitura global de dados que normalmente são bloqueados
 * por RLS. Toda chamada passa por uma SECURITY DEFINER function que
 * tem self-check de is_admin (ver migration 0003). Caller que não é
 * admin recebe erro 42501 do Postgres.
 */

export interface AdminStudentRow {
  displayName: string;
  totalXP: number;
  timeAttackBestScore: number;
  lastPlayedAt: string;
  createdAt: string;
  parentFirstName: string;
  parentLastName: string;
  parentEmail: string;
}

export type AdminResult<T> = { ok: true; value: T } | { ok: false; error: string };

interface RawRow {
  display_name: string;
  total_xp: number;
  time_attack_best_score: number;
  last_played_at: string;
  created_at: string;
  parent_first_name: string;
  parent_last_name: string;
  parent_email: string;
}

export async function getAllStudentsAdmin(): Promise<AdminResult<AdminStudentRow[]>> {
  const { data, error } = await getSupabase().rpc('all_students_admin');
  if (error) return { ok: false, error: error.message };
  const rows = (data ?? []) as RawRow[];
  return { ok: true, value: rows.map(rowToAdminStudent) };
}

function rowToAdminStudent(row: RawRow): AdminStudentRow {
  return {
    displayName: row.display_name,
    totalXP: row.total_xp,
    timeAttackBestScore: row.time_attack_best_score,
    lastPlayedAt: row.last_played_at,
    createdAt: row.created_at,
    parentFirstName: row.parent_first_name,
    parentLastName: row.parent_last_name,
    parentEmail: row.parent_email,
  };
}
